import { render, staticRenderFns } from "./TemList.vue?vue&type=template&id=be1a3016&scoped=true"
import script from "./TemList.vue?vue&type=script&lang=js"
export * from "./TemList.vue?vue&type=script&lang=js"
import style0 from "./TemList.vue?vue&type=style&index=0&id=be1a3016&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be1a3016",
  null
  
)

export default component.exports